module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "chap-head-top"
  }, [_vm._v("CONTENTS")]), _vm._v(" "), _c('div', {
    staticClass: "head"
  }), _vm._v(" "), _c('div', [_c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "toc-indent2",
    attrs: {
      "id": "dedi"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/81388_dedication",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("DEDICATION")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-indent2",
    attrs: {
      "id": "encore"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/81388_encore"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("ENCORE")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-part",
    attrs: {
      "id": "p1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/81388_part1"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("PART ONE: BEGINNINGS")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1-top",
    attrs: {
      "id": "c1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/81388_chapter1"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("1")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/Text/81388_chapter1"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("THE BLACK COUNTRY")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "c2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/81388_chapter2"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("2")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/Text/81388_chapter2"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("THE DEVIL’S MUSIC")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "c3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/81388_chapter3"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("3")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/Text/81388_chapter3"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("KING MOD")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "c4"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/81388_chapter4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("4")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/81388_chapter4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("THE RUBBER MAN")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "c5"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/81388_chapter5",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("5")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/81388_chapter5",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("THE REAL DESPERATION SCENE")])])]), _vm._v(" "), _c('div', [_c('p', {
    staticClass: "toc-part",
    attrs: {
      "id": "p2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/81388_part2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("PART TWO: AIRBORNE")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1-top",
    attrs: {
      "id": "c6"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/81388_chapter6",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("6")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/81388_chapter6",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("BOOM! BOOM! BOOM!")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "c7"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/81388_chapter7",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("7")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/81388_chapter7",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("VALHALLA")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "c8"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/81388_chapter8",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("8")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/81388_chapter8",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("BLOND ELVIS")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "c9"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/81388_chapter9",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("9")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/81388_chapter9",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("SODOM AND GOMORRAH")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "c10"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/81388_chapter10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("10")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/81388_chapter10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("CRASH")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "c11"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/81388_chapter11",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("11")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/81388_chapter11",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("DARKNESS, DARKNESS")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "c12"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/81388_chapter12",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("12")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/81388_chapter12",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("THE OUT DOOR")])])]), _vm._v(" "), _c('div', [_c('p', {
    staticClass: "toc-part",
    attrs: {
      "id": "p3"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/81388_part3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("PART THREE: SOLO")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2-top",
    attrs: {
      "id": "c13"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/81388_chapter13",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("13")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/81388_chapter13",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("EXORCISM")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "c14"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/81388_chapter14",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("14")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/81388_chapter14",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("SEA OF LOVE")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "c15"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/81388_chapter15",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("15")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/81388_chapter15",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("TALL COOL ONE")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "c16"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/81388_chapter16",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("16")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/81388_chapter16",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("CROSSROADS")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "c17"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/81388_chapter17",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("17")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/81388_chapter17",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("GOOD TIMES, BAD TIMES")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "c18"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/81388_chapter18",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("18")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/81388_chapter18",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("DOWN FROM THE MOUNTAIN")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "c19"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/81388_chapter19",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("19")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/81388_chapter19",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("REBIRTH")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "c20"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/81388_chapter20",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("20   GONE, GONE, GONE")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "c21"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/81388_chapter21",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("21   JOY")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "c22"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/81388_chapter22",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("22   CODA")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-indent-top2",
    attrs: {
      "id": "ack"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/81388_acknowledgment",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("ACKNOWLEDGMENTS")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-indent2",
    attrs: {
      "id": "sources"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/81388_sources",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("SOURCES")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-indent2",
    attrs: {
      "id": "ind"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/81388_index",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("INDEX")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-indent2",
    attrs: {
      "id": "photo"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/81388_photoInsert",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("PHOTOGRAPHIC INSERTS")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-indent2",
    attrs: {
      "id": "auth"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/81388_abouttheauthor"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("ABOUT THE AUTHOR")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-indent2",
    attrs: {
      "id": "credits"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/81388_credits",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("CREDITS")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-indent2",
    attrs: {
      "id": "copy"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/81388_copyright",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("COPYRIGHT")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-indent2",
    attrs: {
      "id": "pub"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/81388_ATP",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("ABOUT THE PUBLISHER")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-59af292e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/81388_content.vue
// module id = 66
// module chunks = 0